import './assets/styles/fonts.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Catalog from './pages/Catalog/Catalog';
import CarDetail from './pages/CarDetail/CarDetail';
import ShowroomAppointment from './components/ShowroomAppointment/ShowroomAppointment';
import TestDriveAppointment from './components/TestDriveAppointment/TestDriveAppointment';
import ServiceAppointment from './components/ServiceAppointment/ServiceAppointment';
import GetOffer from './components/GetOfferAppointment/GetOffer';

function App() {
  return (
    <Router>
      <div
        className="app-container"
        style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
      >
        <Header />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalog/new" element={<Catalog type="new" />} />
            <Route path="/catalog/used" element={<Catalog type="used" />} />
            <Route path="/catalog/:type/:id" element={<CarDetail />} />
            <Route path="/visit_showroom" element={<ShowroomAppointment />} />
            <Route path="/test-drive-appointment" element={<TestDriveAppointment />} />
            <Route path="/service-appointment" element={<ServiceAppointment />} />
            <Route path="/poluchit-predlozhenie" element={<GetOffer />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;